import { compose, head } from 'ramda';
import { createAction } from 'redux-actions';
import fetchJsonp from 'fetch-jsonp';

import { logger } from '../../lib/logger';
import { getEnvironment } from '../environment/selectors';
import { createToast } from '../toasts/actions';

export const WIDGET_WORKING = 'WIDGET_WORKING';
export const WIDGET_FINISHED = 'WIDGET_FINISHED';
export const MAIL_SIGNUP = 'MAIL_SIGNUP';

export const beginWork = createAction(WIDGET_WORKING);
export const finishWork = createAction(WIDGET_FINISHED);

const cleanMailchimpMessage = compose(
  head,
  (msg) =>
    [
      [/.*already subscribed.*/, 'You have already subscribed to this list.'],
      [/(.*)/, '$&'],
    ]
      .filter(([test]) => msg.match(test))
      .map(([test, replace]) => msg.replace(test, replace)),
  (msg) => msg.replace(/\d\s-\s/, '')
);

export const mailSignup = createAction(
  MAIL_SIGNUP,
  (email, listId, successMessage) => async (dispatch, getState) => {
    dispatch(beginWork());
    const { MAILCHIMP_ID, MAILCHIMP_HOST, SUPPORT_EMAIL } = compose(
      getEnvironment,
      getState
    )();

    try {
      const response = await fetchJsonp(
        `//${MAILCHIMP_HOST}/subscribe/post-json?u=${MAILCHIMP_ID}&id=${listId}&EMAIL=${encodeURIComponent(
          email
        )}`,
        {
          jsonpCallback: 'c',
        }
      );

      const json = await response.json();
      const { msg, result } = json;

      const toast = {
        message:
          result == 'error' ? cleanMailchimpMessage(msg) : successMessage,
        variables: { email },
        status: result == 'error' ? 'error' : 'ok',
        duration: 8000,
      };

      dispatch(createToast(toast));
    } catch (error) {
      logger.error(error, {
        message: 'Failed to register email to Mailchimp list.',
      });
      dispatch(
        createToast({
          message: `There was an error registering your email. Please notify ${SUPPORT_EMAIL}.`,
          status: 'error',
        })
      );
    }

    dispatch(finishWork());
  }
);
